module.exports = __webpack_public_path__ + "assets/img/newQuestioncomeon@2x.f640f7de.png";